import * as actionTypes from './actionTypes'
import appraisalDropdownAxios from '../../axios/appraisalDropdownOptions.js'

export const fetchCompanyOptionsForAppraisal = filterOptions => {
  let params = null
  if (filterOptions) {
    params = filterOptions
  }
  return dispatch => {
    dispatch(fetchCompanyOptionsForAppraisalStart())
    appraisalDropdownAxios
      .get('/company', {
        params
      })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchCompanyOptionsForAppraisalSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchCompanyOptionsForAppraisalFailed(error))
      })
  }
}

export const fetchCompanyOptionsForAppraisalStart = () => {
  return {
    type: actionTypes.FETCH_COMPANY_OPTIONS_FOR_APPRAISAL_START
  }
}

export const fetchCompanyOptionsForAppraisalSuccess = data => {
  return {
    type: actionTypes.FETCH_COMPANY_OPTIONS_FOR_APPRAISAL_SUCCESS,
    data
  }
}

export const fetchCompanyOptionsForAppraisalFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_COMPANY_OPTIONS_FOR_APPRAISAL_FAILED,
    errorMessage
  }
}

export const fetchStructureOptionsForAppraisal = filterOptions => {
  let params = null
  if (filterOptions) {
    params = filterOptions
  }
  return dispatch => {
    dispatch(fetchStructureOptionsForAppraisalStart())
    appraisalDropdownAxios
      .get('/structure', {
        params
      })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchStructureOptionsForAppraisalSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchStructureOptionsForAppraisalFailed(error))
      })
  }
}

export const fetchStructureOptionsForAppraisalStart = () => {
  return {
    type: actionTypes.FETCH_STRUCTURE_OPTIONS_FOR_APPRAISAL_START
  }
}

export const fetchStructureOptionsForAppraisalSuccess = data => {
  return {
    type: actionTypes.FETCH_STRUCTURE_OPTIONS_FOR_APPRAISAL_SUCCESS,
    data
  }
}

export const fetchStructureOptionsForAppraisalFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_STRUCTURE_OPTIONS_FOR_APPRAISAL_FAILED,
    errorMessage
  }
}

export const fetchLevelGroupOptionsForAppraisal = filterOptions => {
  let params = null
  if (filterOptions) {
    params = filterOptions
  }
  return dispatch => {
    dispatch(fetchLevelGroupOptionsForAppraisalStart())
    appraisalDropdownAxios
      .get('/level_group', {
        params
      })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchLevelGroupOptionsForAppraisalSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchLevelGroupOptionsForAppraisalFailed(error))
      })
  }
}

export const fetchLevelGroupOptionsForAppraisalStart = () => {
  return {
    type: actionTypes.FETCH_LEVEL_GROUP_OPTIONS_FOR_APPRAISAL_START
  }
}

export const fetchLevelGroupOptionsForAppraisalSuccess = data => {
  return {
    type: actionTypes.FETCH_LEVEL_GROUP_OPTIONS_FOR_APPRAISAL_SUCCESS,
    data
  }
}

export const fetchLevelGroupOptionsForAppraisalFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_LEVEL_GROUP_OPTIONS_FOR_APPRAISAL_FAILED,
    errorMessage
  }
}

// Organization

export const fetchOrganizationOptionsForAppraisal = filterOptions => {
  let params = null
  if (filterOptions) {
    params = filterOptions
  }
  return dispatch => {
    dispatch(fetchOrganizationOptionsForAppraisalStart())
    appraisalDropdownAxios
      .get('/org', {
        params
      })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchOrganizationOptionsForAppraisalSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchOrganizationOptionsForAppraisalFailed(error))
      })
  }
}

export const fetchOrganizationOptionsForAppraisalStart = () => {
  return {
    type: actionTypes.FETCH_ORGANIZATION_OPTIONS_FOR_APPRAISAL_START
  }
}

export const fetchOrganizationOptionsForAppraisalSuccess = data => {
  return {
    type: actionTypes.FETCH_ORGANIZATION_OPTIONS_FOR_APPRAISAL_SUCCESS,
    data
  }
}

export const fetchOrganizationOptionsForAppraisalFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_ORGANIZATION_OPTIONS_FOR_APPRAISAL_FAILED,
    errorMessage
  }
}

// Position

export const fetchPositionOptionsForAppraisal = filterOptions => {
  let params = null
  if (filterOptions) {
    params = filterOptions
  }
  return dispatch => {
    dispatch(fetchPositionOptionsForAppraisalStart())
    appraisalDropdownAxios
      .get('/position', {
        params
      })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchPositionOptionsForAppraisalSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchPositionOptionsForAppraisalFailed(error))
      })
  }
}

export const fetchPositionOptionsForAppraisalStart = () => {
  return {
    type: actionTypes.FETCH_POSITION_OPTIONS_FOR_APPRAISAL_START
  }
}

export const fetchPositionOptionsForAppraisalSuccess = data => {
  return {
    type: actionTypes.FETCH_POSITION_OPTIONS_FOR_APPRAISAL_SUCCESS,
    data
  }
}

export const fetchPositionOptionsForAppraisalFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_POSITION_OPTIONS_FOR_APPRAISAL_FAILED,
    errorMessage
  }
}

// Employee

export const fetchEmployeeOptionsForAppraisal = filterOptions => {
  let params = null
  if (filterOptions) {
    params = filterOptions
  }
  return dispatch => {
    dispatch(fetchEmployeeOptionsForAppraisalStart())
    appraisalDropdownAxios
      .get('/employee', {
        params
      })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchEmployeeOptionsForAppraisalSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchEmployeeOptionsForAppraisalFailed(error))
      })
  }
}

export const fetchEmployeeOptionsForAppraisalStart = () => {
  return {
    type: actionTypes.FETCH_EMPLOYEE_OPTIONS_FOR_APPRAISAL_START
  }
}

export const fetchEmployeeOptionsForAppraisalSuccess = data => {
  return {
    type: actionTypes.FETCH_EMPLOYEE_OPTIONS_FOR_APPRAISAL_SUCCESS,
    data
  }
}

export const fetchEmployeeOptionsForAppraisalFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_EMPLOYEE_OPTIONS_FOR_APPRAISAL_FAILED,
    errorMessage
  }
}

// Form Options

export const fetchFormOptionsForAppraisal = filterOptions => {
  let params = null
  if (filterOptions) {
    params = filterOptions
  }
  return dispatch => {
    dispatch(fetchFormOptionsForAppraisalStart())
    appraisalDropdownAxios
      .get('/form', {
        params
      })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchFormOptionsForAppraisalSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchFormOptionsForAppraisalFailed(error))
      })
  }
}

export const fetchFormOptionsForAppraisalStart = () => {
  return {
    type: actionTypes.FETCH_FORM_OPTIONS_FOR_APPRAISAL_START
  }
}

export const fetchFormOptionsForAppraisalSuccess = data => {
  return {
    type: actionTypes.FETCH_FORM_OPTIONS_FOR_APPRAISAL_SUCCESS,
    data
  }
}

export const fetchFormOptionsForAppraisalFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_FORM_OPTIONS_FOR_APPRAISAL_FAILED,
    errorMessage
  }
}

// Criteria

export const fetchCriteriaOptionsForAppraisal = filterOptions => {
  let params = null
  if (filterOptions) {
    params = filterOptions
  }
  return dispatch => {
    dispatch(fetchCriteriaOptionsForAppraisalStart())
    appraisalDropdownAxios
      .get('/criteria', {
        params
      })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchCriteriaOptionsForAppraisalSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchCriteriaOptionsForAppraisalFailed(error))
      })
  }
}

export const fetchCriteriaOptionsForAppraisalStart = () => {
  return {
    type: actionTypes.FETCH_CRITERIA_OPTIONS_FOR_APPRAISAL_START
  }
}

export const fetchCriteriaOptionsForAppraisalSuccess = data => {
  return {
    type: actionTypes.FETCH_CRITERIA_OPTIONS_FOR_APPRAISAL_SUCCESS,
    data
  }
}

export const fetchCriteriaOptionsForAppraisalFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_CRITERIA_OPTIONS_FOR_APPRAISAL_FAILED,
    errorMessage
  }
}

export const fetchResponsibleOptionsForAppraisal = (filterOptions, structureId, itemData) => {
  let params = null
  if (filterOptions) {
    params = filterOptions
  }
  return dispatch => {
    dispatch(fetchResponsibleOptionsForAppraisalStart())
    appraisalDropdownAxios
      .get('/responsible', {
        params
      })
      .then(response => {
        if (response.status === 200) {
          dispatch(
            fetchResponsibleOptionsForAppraisalSuccess(response.data.data, structureId, itemData)
          )
        }
      })
      .catch(error => {
        dispatch(fetchResponsibleOptionsForAppraisalFailed(error))
      })
  }
}

export const fetchResponsibleOptionsForAppraisalStart = () => {
  return {
    type: actionTypes.FETCH_RESPONSIBLE_OPTIONS_FOR_APPRAISAL_START
  }
}

export const fetchResponsibleOptionsForAppraisalSuccess = (data, structureId, itemData) => {
  return {
    type: actionTypes.FETCH_RESPONSIBLE_OPTIONS_FOR_APPRAISAL_SUCCESS,
    data,
    structureId,
    itemData
  }
}

export const fetchResponsibleOptionsForAppraisalFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_RESPONSIBLE_OPTIONS_FOR_APPRAISAL_FAILED,
    errorMessage
  }
}

export const fetchAppraisalStatusOptionsForAppraisal = filterOptions => {
  let params = null
  if (filterOptions) {
    params = filterOptions
  }
  return dispatch => {
    dispatch(fetchAppraisalStatusOptionsForAppraisalStart())
    appraisalDropdownAxios
      .get('/appraisal_status', {
        params
      })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchAppraisalStatusOptionsForAppraisalSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchAppraisalStatusOptionsForAppraisalFailed(error))
      })
  }
}

export const fetchAppraisalStatusOptionsForAppraisalStart = () => {
  return {
    type: actionTypes.FETCH_APPRAISAL_STATUS_OPTIONS_FOR_APPRAISAL_START
  }
}

export const fetchAppraisalStatusOptionsForAppraisalSuccess = data => {
  return {
    type: actionTypes.FETCH_APPRAISAL_STATUS_OPTIONS_FOR_APPRAISAL_SUCCESS,
    data
  }
}

export const fetchAppraisalStatusOptionsForAppraisalFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_APPRAISAL_STATUS_OPTIONS_FOR_APPRAISAL_FAILED,
    errorMessage
  }
}

export const fetchAssignmentStatusOptionsForAppraisal = filterOptions => {
  let params = null
  if (filterOptions) {
    params = filterOptions
  }
  return dispatch => {
    dispatch(fetchAssignmentStatusOptionsForAppraisalStart())
    appraisalDropdownAxios
      .get('/assignment_status', {
        params
      })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchAssignmentStatusOptionsForAppraisalSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchAssignmentStatusOptionsForAppraisalFailed(error))
      })
  }
}

export const fetchAssignmentStatusOptionsForAppraisalStart = () => {
  return {
    type: actionTypes.FETCH_ASSIGNMENT_STATUS_OPTIONS_FOR_APPRAISAL_START
  }
}

export const fetchAssignmentStatusOptionsForAppraisalSuccess = data => {
  return {
    type: actionTypes.FETCH_ASSIGNMENT_STATUS_OPTIONS_FOR_APPRAISAL_SUCCESS,
    data
  }
}

export const fetchAssignmentStatusOptionsForAppraisalFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_ASSIGNMENT_STATUS_OPTIONS_FOR_APPRAISAL_FAILED,
    errorMessage
  }
}

export const fetchAppraisalTypeOptionsForAppraisal = filterOptions => {
  let params = null
  if (filterOptions) {
    params = filterOptions
  }
  return dispatch => {
    dispatch(fetchAppraisalTypeOptionsForAppraisalStart())
    appraisalDropdownAxios
      .get('/appraisal_type', {
        params
      })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchAppraisalTypeOptionsForAppraisalSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchAppraisalTypeOptionsForAppraisalFailed(error))
      })
  }
}

export const fetchAppraisalTypeOptionsForAppraisalStart = () => {
  return {
    type: actionTypes.FETCH_APPRAISAL_TYPE_OPTIONS_FOR_APPRAISAL_START
  }
}

export const fetchAppraisalTypeOptionsForAppraisalSuccess = data => {
  return {
    type: actionTypes.FETCH_APPRAISAL_TYPE_OPTIONS_FOR_APPRAISAL_SUCCESS,
    data
  }
}

export const fetchAppraisalTypeOptionsForAppraisalFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_APPRAISAL_TYPE_OPTIONS_FOR_APPRAISAL_FAILED,
    errorMessage
  }
}

// Forced Organization

export const fetchForcedOrganizationOptionsForAppraisal = filterOptions => {
  let params = null
  if (filterOptions) {
    params = filterOptions
  }
  return dispatch => {
    dispatch(fetchForcedOrganizationOptionsForAppraisalStart())
    appraisalDropdownAxios
      .get('/forced_org', {
        params
      })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchForcedOrganizationOptionsForAppraisalSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchForcedOrganizationOptionsForAppraisalFailed(error))
      })
  }
}

export const fetchForcedOrganizationOptionsForAppraisalStart = () => {
  return {
    type: actionTypes.FETCH_FORCED_ORGANIZATION_OPTIONS_FOR_APPRAISAL_START
  }
}

export const fetchForcedOrganizationOptionsForAppraisalSuccess = data => {
  return {
    type: actionTypes.FETCH_FORCED_ORGANIZATION_OPTIONS_FOR_APPRAISAL_SUCCESS,
    data
  }
}

export const fetchForcedOrganizationOptionsForAppraisalFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_FORCED_ORGANIZATION_OPTIONS_FOR_APPRAISAL_FAILED,
    errorMessage
  }
}
